<template>
  <div class="app-main-content home">
    <h1>State of Rhode Island DMV Online Service System</h1>
    <p>
      Visit the <BaseLinkOpenNew url="https://dmv.ri.gov/online-services" name="RI DMV Online Services" />
      page for a full listing of all DMV online services.
    </p>

    <h2>Frequently visited links</h2>
    <ul>
      <li>
        <router-link :to="{ name: 'VehicleLookup' }">Look up your vehicle registration status</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'GuestSignin' }">Sign in to access your profile</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import BaseLinkOpenNew from "@/components/ui/BaseLinkOpenNew"

export default {
  name: 'Home',
  page: {
    title: `Home | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: `${appConfig.description}`
      }
    ]
  },
  components: {
    BaseLinkOpenNew,
  }
}
</script>

<style lang="scss" scoped>
.home {
  h2 {
    margin-top: 1.25em;
  }
  ul {
    margin-top: 1em;
    li {
      min-height: 2rem;
    }
  }
}
</style>
